import { SxProps, Typography } from '@mui/material'
import React from 'react'

export const FormTopLabel: React.FC<{ required?: boolean, size?: 'small' | 'medium', sx?: SxProps, className?: string }> = ({ children, required = false, size = undefined, sx, className }) => {
  return (
    <Typography
      className={className !== undefined
        ? className
        : `form-element-label ${size ?? ''}`}
      sx={
        {
          marginRight: '5px',
          fontWeight: 700,
          color: '#17374f',
          marginTop: '4px',
          ...(typeof sx === 'object' ? sx : {})
        }
      }
    >
      {children}
      {required && '\u00A0*'}
    </Typography>
  )
}
